import React from "react";
import { Container, MenuItem, Stack, Tooltip } from "@mui/material";
import Iconify from "../components/iconify/Iconify";
// import Typography from "../theme/overrides/Typography";

export default function UserDetails({ user, onClose, handleDelete }) {
  console.log(user);
  return (
    <Container>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <h5>User Details:</h5>

        <MenuItem sx={{ color: "black" }} onClick={onClose}>
        <Tooltip title="Close">
          <Iconify icon={"eva:close-fill"} sx={{ mr: 2 }} />
          </Tooltip>
        </MenuItem>
      </Stack>
      <p>Membership Number: {user.membership_no}</p>
      <p>Name: {user.first_name + " " + user.last_name}</p>
      <p>Email: {user.email}</p>
      <p>Address Line1: {user.address_line1}</p>
      <p>Address Line2: {user.address_line2}</p>
      <p>City: {user.city}</p>
      <p>Zip Code: {user.zip_code}</p>
      <p>State: {user.state}</p>
      <p>Country: {user.country + " (+" + user.country_code + ")"}</p>
      <p>Phone Number: {user.phone}</p>
      <p>Account Number: {user.account_no}</p>
      <p>Routing Number: {user.routing_no}</p>
      {user.card_details.map((card, i) => (
        <p key={i}>
          Card Number: {card.card_number} ( {card.card_type})
        </p>
      ))}
      {/* <p>membership_fee: {user.membership_fee}</p> */}
      {/* <p>membership_end: {user.membership_end}</p> */}
      <p>Membership Status: {user.membership_status}</p>
      {user.location.coordinates ? <p>Location Coordinates: (Lat: {user.location.coordinates[1]}, Long: {user.location.coordinates[0]}
      )</p>:<p>Location Coordinates not found</p>}
      {/* <p>customer_id: {user.customer_id}</p> */}
      <p>Ratings: {user.ratings}</p>
      <p>Number Of Reviews: {user.num_of_reviews}</p>
      <p>Profile: {user.profile}</p>

      {/* <button style={{ border: "none", background: "inherit" }}>
        <MenuItem
          sx={{ color: "error.main" }}
          onClick={() => handleDelete(user.membership_no)}
        >
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete User
        </MenuItem>
      </button> */}
    </Container>
  );
}
